export const Status = {
  PENDING: {
    color: '#ccc',
    colorClassName: 'text-muted',
    tkey: 'status.pending',
  },
  WORKING: {
    color: '#7930e2',
    colorClassName: 'text-primary',
    tkey: 'status.working',
  },
  DONE: {
    color: '#198754',
    colorClassName: 'text-success',
    tkey: 'status.done',
  },
  NOT_DONE: {
    color: '#ffc107',
    colorClassName: 'text-warning',
    tkey: 'status.not_done',
  },
  FAILED: {
    color: '#dc3545',
    colorClassName: 'text-danger',
    tkey: 'status.failed',
  },
  CANCELED: {
    color: '#ccc',
    colorClassName: 'text-muted',
    tkey: 'status.canceled',
  },
};
